(function () {
    'use strict';

    angular.module('thankview.global')
        .factory('hubspotService', ['$timeout', '$document', '$window', function ($timeout, $document, $window) {
            const hubspotService = {};
            // portal ID assigned to ThankView in hubspot
            const hubspotPortalID = '8568018';
            let initialized = false;

            /**
             * Initialize hubspot. Add a jQuery object so hubspot
             * callbacks will work
             */
            hubspotService.init = function () {
                if (initialized) {
                    return;
                }

                // Workaround to get callbacks to work
                // Source - https://www.unstack.com/blog/hubspot-on-form-submit-callbacks-without-jquery
                if (!$window.jQuery) {
                    $window.jQuery = (nodeOrSelector) => {
                        if (typeof (nodeOrSelector) === 'string') {
                            return $document[0].querySelector();
                        }
                        return nodeOrSelector;
                    };
                }

                initialized = true;
            };

            /**
             * Load hubspot see example form
             *
             * @param {Object} options - hubspot configuration
             */
            hubspotService.loadSeeExampleForm = function (options) {
                // fix race condition if hubspot forms isn't loaded
                if (!$window.hbspt) {
                    $timeout(() => {
                        hubspotService.loadSeeExampleForm(options);
                    }, 100);
                    return;
                }

                hubspotService.init();

                let config = {
                    region: 'na1',
                    portalId: hubspotPortalID,
                    formId: 'e7687c9b-643d-4f1d-9426-4cddcbd4b4c3',
                };

                config = angular.extend(config, options);

                $window.hbspt.forms.create(config);
            };

            /**
             * Load hubspot demo form
             *
             * @param {Object} options - hubspot configuration
             */
            hubspotService.loadDemoForm = function (options) {
                // fix race condition if hubspot forms isn't loaded
                if (!$window.hbspt) {
                    $timeout(() => {
                        hubspotService.loadDemoForm(options);
                    }, 100);
                    return;
                }

                hubspotService.init();

                let config = {
                    portalId: hubspotPortalID,
                    formId: '80184a4d-af23-4f3d-be58-bdbe06dd16ab',
                };

                config = angular.extend(config, options);

                $window.hbspt.forms.create(config);
            };

            return hubspotService;
        }]);
}());
